import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class GetOwnersFindCommand extends IRequestCommand<
  IGetOwnersFindResponse[],
  ErrorDetails,
  IGetOwnersFindParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public override setParameters(parameters: IGetOwnersFindParameters) {
    this.urlSections.push('carrierOwnerLiquidations');
    this.urlSections.push(`${parameters.carrierId}`);
    this.urlSections.push('findOwners');
    this.composeUrl();
  }
}

export interface IGetOwnersFindParameters {
  carrierId: string;
}

export interface IGetOwnersFindResponse extends ICommandResponse {
  name: string;
  lastName: string;
  carrierId: number;
  ownerId: number;
  travelSurrenderId: number;
  creationDate: string;
  lastLiquidationDate: string;
  lastLiquidationId: number;
  toLiquidate: number;
}
